import './availability.controller.js';



// WEBPACK FOOTER //
// ./components/schedule/check-availability/index.js